import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { patchPrimeNgColumnFilterApplyBehavior } from './app/core/config/primeng-table-filter.behavior';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

// Apply once at startup so issue fixes (#2/#3/#4) are consistent for all PrimeNG column filter menus.
patchPrimeNgColumnFilterApplyBehavior();

platformBrowserDynamic()
	.bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
	.catch(err => console.error(err));
